import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import FieldList from 'Components/Universal/Questionnaire/Fields/FieldList';

const InvestmentRiskProfileSectionPicker = ({
  clientResource, Windfalls, setWindfallCount,
}) => {
  return pickFunction(clientResource, {
    [fr.relationships.default.name]: () => (<FieldList
      onCountUpdate={setWindfallCount}
      label="Anticipated extraordinary windfalls"
      addLabel="Add a windfall"
      keyPrefix="windfalls"
      Of={Windfalls}
    />),
  });
};

export default InvestmentRiskProfileSectionPicker;
